/**
 * @generated SignedSource<<0267d67ec09afec9377d86e290b59063>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articlePaginationNavigationHistoryArticle$data = {
  readonly entityId: string;
  readonly urlAlias: string;
  readonly " $fragmentSpreads": FragmentRefs<"hooksTrackCurrentItemBase">;
  readonly " $fragmentType": "articlePaginationNavigationHistoryArticle";
};
export type articlePaginationNavigationHistoryArticle$key = {
  readonly " $data"?: articlePaginationNavigationHistoryArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articlePaginationNavigationHistoryArticle">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "defaultValue": "PARAGRAPH",
    "kind": "LocalArgument",
    "name": "bodyType"
  },
  {
    "defaultValue": ([]/*: any*/),
    "kind": "LocalArgument",
    "name": "customContents"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "bodyType",
    "variableName": "bodyType"
  },
  {
    "kind": "Variable",
    "name": "customContents",
    "variableName": "customContents"
  }
],
v5 = [
  (v1/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = [
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v9 = [
  (v1/*: any*/),
  (v6/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegment",
  "kind": "LinkedField",
  "name": "sections",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": (v9/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegment",
  "kind": "LinkedField",
  "name": "sections",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": (v7/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SectionSegment",
    "kind": "LinkedField",
    "name": "sections",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Section",
        "kind": "LinkedField",
        "name": "value",
        "plural": true,
        "selections": (v5/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v13 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "entityLink"
};
return {
  "argumentDefinitions": (v0/*: any*/),
  "kind": "Fragment",
  "metadata": null,
  "name": "articlePaginationNavigationHistoryArticle",
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "kind": "InlineDataFragmentSpread",
      "name": "hooksTrackCurrentItemBase",
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v3/*: any*/),
            {
              "kind": "InlineDataFragmentSpread",
              "name": "atomsCurrentArticleAtomBase",
              "selections": [
                (v3/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "articleHeadlineHeaderFeaturesArticle",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "headline",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "socialHeadline",
                          "storageKey": null
                        }
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    },
                    {
                      "args": (v4/*: any*/),
                      "kind": "FragmentSpread",
                      "name": "articleSeoArticle"
                    },
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "bookmarkHeaderFeaturesArticle",
                      "selections": (v5/*: any*/),
                      "args": null,
                      "argumentDefinitions": []
                    },
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "commentHeaderFeaturesArticle",
                      "selections": [
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "articleCommentsTriggerArticle"
                        }
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "contentShareWidgetContent"
                    },
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "helpersCheckIsStyleArticle",
                      "selections": [
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "SectionSegmentV2",
                              "kind": "LinkedField",
                              "name": "sectionsV2",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": null,
                                  "kind": "LinkedField",
                                  "name": "value",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "kind": "InlineFragment",
                                      "selections": (v5/*: any*/),
                                      "type": "Section",
                                      "abstractKey": null
                                    },
                                    {
                                      "kind": "InlineFragment",
                                      "selections": (v5/*: any*/),
                                      "type": "VideoSection",
                                      "abstractKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "type": "Content",
                          "abstractKey": "__isContent"
                        }
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    },
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "helpersUseSharingUrl",
                      "selections": [
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v2/*: any*/)
                          ],
                          "type": "Content",
                          "abstractKey": "__isContent"
                        }
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "articleShareWidgetArticle"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "hooksTrackPageViewArticle"
                    },
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "hooksContentInterestArticle",
                      "selections": [
                        (v1/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "sentiment",
                          "storageKey": null
                        },
                        (v2/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ArticleTypeSegment",
                          "kind": "LinkedField",
                          "name": "types",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "ArticleType",
                              "kind": "LinkedField",
                              "name": "value",
                              "plural": true,
                              "selections": (v7/*: any*/),
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        (v8/*: any*/)
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    },
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "hooksUseCurrentArticleIdsArticle",
                      "selections": [
                        (v1/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "entityUuid",
                          "storageKey": null
                        }
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    },
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "hooksUseCurrentArticlePrebidConfigArticle",
                      "selections": [
                        (v10/*: any*/),
                        (v8/*: any*/)
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    },
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "hooksUsePageTargetingArticle",
                      "selections": [
                        (v11/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Topic",
                          "kind": "LinkedField",
                          "name": "firstTopic",
                          "plural": false,
                          "selections": (v7/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    },
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "onboardingNewsletterSubscriptionArticle",
                      "selections": (v12/*: any*/),
                      "args": null,
                      "argumentDefinitions": []
                    },
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "entityLinkHeaderFeaturesArticle",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Author",
                          "kind": "LinkedField",
                          "name": "authors",
                          "plural": true,
                          "selections": [
                            (v6/*: any*/),
                            (v13/*: any*/)
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SectionSegment",
                          "kind": "LinkedField",
                          "name": "sections",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Section",
                              "kind": "LinkedField",
                              "name": "value",
                              "plural": true,
                              "selections": [
                                (v6/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "published",
                                  "storageKey": null
                                },
                                (v13/*: any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    },
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "shareHeaderFeaturesContent",
                      "selections": [
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "shareArticle20Content"
                            }
                          ],
                          "type": "Content",
                          "abstractKey": "__isContent"
                        }
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    },
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "abandonedCartOfferDialogArticle",
                      "selections": [
                        (v11/*: any*/),
                        (v8/*: any*/)
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    }
                  ],
                  "type": "Article",
                  "abstractKey": null
                }
              ],
              "args": (v4/*: any*/),
              "argumentDefinitions": (v0/*: any*/)
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "atomsCurrentTakeoverAdSectionsAtomBase",
              "selections": [
                (v3/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": (v12/*: any*/),
                  "type": "Article",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Section",
                      "kind": "LinkedField",
                      "name": "fullSectionPath",
                      "plural": true,
                      "selections": (v5/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "type": "Section",
                  "abstractKey": null
                }
              ],
              "args": null,
              "argumentDefinitions": []
            },
            {
              "kind": "InlineDataFragmentSpread",
              "name": "atomsCurrentStyleCardCarouselWidgetSectionsAtomBase",
              "selections": [
                (v3/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v10/*: any*/)
                  ],
                  "type": "Article",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Section",
                      "kind": "LinkedField",
                      "name": "fullSectionPath",
                      "plural": true,
                      "selections": (v9/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "type": "Section",
                  "abstractKey": null
                }
              ],
              "args": null,
              "argumentDefinitions": []
            }
          ],
          "type": "BaseWithApplicationAndUrlAlias",
          "abstractKey": "__isBaseWithApplicationAndUrlAlias"
        }
      ],
      "args": (v4/*: any*/),
      "argumentDefinitions": (v0/*: any*/)
    }
  ],
  "type": "Article",
  "abstractKey": null
};
})();

(node as any).hash = "c661cab2643b8858db571c34a3915949";

export default node;
